import { useState } from "react";
import { editReservation } from "../../../api/reservation";

import ImageDropzone from "../../../component/ImageDropZone";
import { PageContentHeaderButton } from "../../../styles/page";
import {
  ImageDropWrapper,
  ReservationEditActions,
  ReservationEditPopupContentBodyWrapper,
  ReservationEditPopupContentHeaderWrapper,
  ReservationEditPopupContentWrapper,
  ReservationEditPopupContainer,
  ImageDropInitialContent,
} from "../styles/editReservationPopup";

interface EditReservationImagePopupProps {
  reservationId?: number;
  setIsEditOpen: (isOpen: boolean) => void;
  imageUrl?: string;
}

const EditReservationImagePopup = ({
  reservationId,
  setIsEditOpen,
  imageUrl,
}: EditReservationImagePopupProps) => {
  const [file, setFile] = useState<File | null>(null);

  const updateImage = async () => {
    if (!file) {
      alert("이미지를 선택해주세요.");
      return;
    }
    if (!reservationId) return;
    try {
      const formData = new FormData();
      formData.append("file", file);

      await editReservation(reservationId, formData);
      setIsEditOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleImageUpload = (file: File) => {
    setFile(file);
  };

  return (
    <ReservationEditPopupContainer>
      <ReservationEditPopupContentWrapper>
        <ReservationEditPopupContentHeaderWrapper>
          <span>예약 수정</span>
          <img
            src="/image-web/tournament/close.svg"
            onClick={() => setIsEditOpen(false)}
            alt="Close"
          />
        </ReservationEditPopupContentHeaderWrapper>
        <ReservationEditPopupContentBodyWrapper>
          <ImageDropWrapper>
            <ImageDropzone
              onImageUpload={handleImageUpload}
              defaultUrl={imageUrl}
              children={{
                empty: <p>클릭하여 이미지 업로드 (400x400 ~ 800x800)</p>,
                preview: (
                  <ImageDropInitialContent>
                    <svg
                      width="85"
                      height="85"
                      viewBox="0 0 85 85"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.7016 33.9328C30.3403 33.9328 34.1008 30.1724 34.1008 25.5336C34.1008 20.8948 30.3403 17.1344 25.7016 17.1344C21.0628 17.1344 17.3024 20.8948 17.3024 25.5336C17.3024 30.1724 21.0628 33.9328 25.7016 33.9328Z"
                        fill="#CBCBCB"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M51.4032 0H33.5968C15.0418 0 0 15.0418 0 33.5968V51.4032C0 69.9582 15.0418 85 33.5968 85H51.4032C69.9582 85 85 69.9582 85 51.4032V33.5968C85 24.6864 81.4604 16.1409 75.1597 9.84029C68.8591 3.53966 60.3136 0 51.4032 0ZM33.5968 6.29941H51.4032C65.0347 6.32071 76.5611 16.3951 78.4066 29.9012H71.8972C54.3713 29.9155 38.1656 39.2169 29.3132 54.3429C23.785 49.9514 16.9293 47.5675 9.86907 47.5815H6.29941V33.5968C6.32253 18.5305 18.5305 6.32253 33.5968 6.29941ZM9.86907 53.8809H6.4254C7.33767 63.7847 13.5642 72.4086 22.6779 76.3908C22.9789 70.785 24.2432 65.2729 26.4155 60.0963C21.8315 56.0946 15.9541 53.8869 9.86907 53.8809ZM51.4032 78.7006H33.5968C32.018 78.6943 30.4432 78.5396 28.8933 78.2386C29.4176 54.8525 48.5052 36.1563 71.8972 36.1166H78.7006V51.4032C78.6775 66.4695 66.4695 78.6775 51.4032 78.7006Z"
                        fill="#CBCBCB"
                      />
                    </svg>

                    <h2>변경할 이미지를 올려주세요!</h2>
                    <p>최소 400px * 400px,</p>
                    <p>최대 1600px * 1600px로 설정할 수 있습니다.</p>
                  </ImageDropInitialContent>
                ),
              }}
            ></ImageDropzone>
          </ImageDropWrapper>
          <ReservationEditActions>
            <PageContentHeaderButton
              $weight={1}
              $variant={"positive"}
              onClick={updateImage}
            >
              예약 수정하기
            </PageContentHeaderButton>
          </ReservationEditActions>
        </ReservationEditPopupContentBodyWrapper>
      </ReservationEditPopupContentWrapper>
    </ReservationEditPopupContainer>
  );
};

export default EditReservationImagePopup;
